export const smartech = (method, ...args) => {
    if (window && window.smartech) {
        window.smartech(method, ...args);
    } else {
        console.error("Smartech is not initialized or not available.");
    }
};